import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import it from './locales/it.json';
import en from './locales/en.json';

// Legge la lingua direttamente da localStorage per evitare dipendenze circolari con useBrand
const getSavedLang = () => {
    try {
        const brand = JSON.parse(localStorage.getItem('psc_brand') || '{}');
        return brand.lingua_interfaccia || localStorage.getItem('psc_lingua') || 'it';
    } catch {
        return localStorage.getItem('psc_lingua') || 'it';
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources: {
            it: { translation: it },
            en: { translation: en },
        },
        lng: getSavedLang(),
        fallbackLng: 'it',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
